import React from 'react'
import Layout from '../components/Layout'
import ContractTabs from '../components/ContractTabs'
import ContractCompanyDebt from '../components/ContractCompanyDebt'
import { checkPermission as cp } from '../utils/auth'
import { PermissionDenied } from '../components/PermissionDenied'

/** Korxonalarning barcha oylar bo'yicha umumiy qarzi. */
export default function ContractDebt() {
    if (!cp('billing.view_contractinvoice')) {
        return <PermissionDenied />
    }

    return (
        <Layout>
            <span className="is-size-4">Общий долг компаний</span>
            <br /><br />
            <ContractTabs />
            <ContractCompanyDebt />
        </Layout>
    )
}
